import register from '../util/register'
import angular from 'angular'
import AlertCountController from './AlertCountController'
import AlertCountService from './AlertCountService'
import AlertCountCircle from './AlertCountCircle.directive'

var alertCount = angular.module('app.alertCount', [])

register('app.alertCount')
  .service('AlertCountService', AlertCountService)
  .controller('AlertCountController', AlertCountController)
  .directive('alertCountCircle', AlertCountCircle)

alertCount.run()
